const config = {
    "baseURL": "/api",
    "baseAPIURL": "/api/api",
    "baseAuthURL": "/api/auth/",
    "appToken":"71637ba9af534a35edf9cedd67d454c329bb02cc",
    "CDSFURL": "http://cdsf.govt.lc",
    "timeoutInterval": 300000 // timeout interval in milliseconds
};

export default config



// WEBPACK FOOTER //
// ./src/config.js